const PGA_SUFFIX = ", PGA";
const MEMBER_TYPE = "MB";

const ensurePgaSuffix = (name, memberTypeLabel) => {
  if (!name) return name;
  if (memberTypeLabel !== MEMBER_TYPE) return name;
  const trimmed = name.trimEnd();
  if (trimmed.endsWith(PGA_SUFFIX)) return trimmed;
  return `${name}${PGA_SUFFIX}`;
};

export default ensurePgaSuffix;
